import { createReducer } from '@reduxjs/toolkit';
import { apiRequestSuccess } from 'services/api/api.actions';
import {
  getBonusFreebetDetailEndpoint,
  getBonusListEndpoint,
  getBonusSpendabilityEndpoint,
  getFunBonusDetailApiConfig,
  getFunBonusList,
  getGameBonusDetailEndpoint,
  getGameBonusEndpoint,
  getNewBonusListEndpoint,
} from 'services/bonus/bonus.config';
import {
  BonusSpendability,
  GameBonus,
  GameBonusDetail,
  GameBonusFunDetail,
  GameBonusServiceResponse,
  GameBonusWagerDetail,
  GetBonusSpendabilityResponse,
} from 'services/bonus/bonus.types';

const initialState = {
  gameBonus: [] as GameBonus[],
  gameBonusDetail: [] as GameBonusDetail[],
  bonusList: [] as GameBonusServiceResponse[],
  totalSize: 0,
  bonusWagerDetail: null as null | GameBonusWagerDetail,
  bonusFunDetail: null as null | GameBonusFunDetail,
  spendability: [] as BonusSpendability[],
};

const bonusReducer = createReducer(initialState, (builder) =>
  builder.addCase(apiRequestSuccess, (state, action) => {
    const { payload } = action;

    if (payload.resourceId === getGameBonusEndpoint) {
      const gameBonusList: GameBonus[] | undefined =
        payload.response.data.atenaActiveGameBonusList;
      state.gameBonus = Array.isArray(gameBonusList) ? gameBonusList : [];
      return;
    }

    if (payload.resourceId === getBonusListEndpoint) {
      const getBonusList = payload.response.data;
      if (Array.isArray(getBonusList.responseObject)) {
        state.bonusList = getBonusList.responseObject;
        state.totalSize = getBonusList.totalSize;
      } else {
        state.bonusList = [];
      }
      return;
    }

    if (payload.resourceId === getFunBonusList) {
      const getBonusList = payload.response.data;
      if (Array.isArray(getBonusList.responseObject)) {
        state.bonusList = getBonusList.responseObject;
        state.totalSize = getBonusList.totalSize;
      } else {
        state.bonusList = [];
      }
      return;
    }

    if (payload.resourceId === getGameBonusDetailEndpoint) {
      const gameBonusDetail = payload.response.data.atenaActiveGamesList;
      state.gameBonusDetail = Array.isArray(gameBonusDetail)
        ? gameBonusDetail
        : [];
      return;
    }

    if (payload.resourceId === getNewBonusListEndpoint) {
      const getBonusListResponse = payload.response.data;
      if (Array.isArray(getBonusListResponse.responseObject)) {
        state.bonusList = getBonusListResponse.responseObject;
        state.totalSize = getBonusListResponse.totalSize;
      } else {
        state.bonusList = [];
      }
      return;
    }

    if (payload.resourceId === getBonusFreebetDetailEndpoint) {
      state.bonusWagerDetail = payload.response.data.responseObject ?? null;
      return;
    }

    if (payload.resourceId === getFunBonusDetailApiConfig) {
      state.bonusFunDetail = payload.response.data.responseObject ?? null;
      return;
    }

    if (payload.resourceId === getBonusSpendabilityEndpoint) {
      const data: GetBonusSpendabilityResponse = payload.response.data;

      if (Array.isArray(data?.bonuses)) {
        state.spendability = data.bonuses.map((b) => ({
          source: b.source,
          bonusTypeCode: b.bonusTypeCode ?? '',
          bonusTypeDescription: b.bonusTypeDescription ?? '',
          originalAmount: Number(b.originalAmount ?? 0),
          residualAmount: Number(b.residualAmount ?? 0),
          products: Array.isArray(b.products)
            ? b.products.map((p: any) => ({
                code: p?.code ?? '',
                description: p?.description ?? '',
                originalAmount: Number(p?.originalAmount ?? 0),
                residualAmount: Number(p?.residualAmount ?? 0),
              }))
            : [],
        }));
        return;
      } else {
        state.spendability = [];
        return;
      }
    }
  }),
);

export default bonusReducer;
